import {
  SignInWrapper,
  SignInMainForm,
  SignInFormContainer,
  SignInFormWrapper,
  SignInFormContainerPadding,
  SignInFormSpacer,
} from './styles'

import { CreateAccountPrompt } from './containers/CreateAccountPrompt/CreateAccountPrompt'
import { FormSignEmail } from './containers/FormSigninEmail/FormSigninEmail'
import LogoNomosArkoSvg from '../../../assets/logos/logo-nomos-arko.svg'
import { Helmet } from 'react-helmet'

export function SigninEmailView() {
  return (
    <SignInWrapper>
      <Helmet>
        <title>Nomos - Login</title>
      </Helmet>

      <SignInMainForm>
        <SignInFormSpacer />
        <SignInFormWrapper>
          <img height={54} src={LogoNomosArkoSvg} alt="Nomos" />
          <SignInFormContainer>
            <SignInFormContainerPadding>
              <FormSignEmail />
            </SignInFormContainerPadding>
          </SignInFormContainer>
          <CreateAccountPrompt />
        </SignInFormWrapper>
        <SignInFormSpacer />
      </SignInMainForm>
    </SignInWrapper>
  )
}
